// extracted by mini-css-extract-plugin
export var cardWrapper = "Leadership-module--cardWrapper--7500d";
export var fadeInAnimation = "Leadership-module--fadeInAnimation--a29de";
export var leadership = "Leadership-module--leadership--a8bbb";
export var sliderLayout = "Leadership-module--sliderLayout--0570f";